export default [
  {
    path: '/devices',
    name: 'devices',
    component: () => import('@/views/devices/DevicesMain.vue'),
  },
  // {
  //   path: '/devices/create',
  //   name: 'devices-create',
  //   component: () => import('@/views/devices/DevicesCreate.vue'),
  //   meta: {transitionName: 'zoom'},
  // },
  {
    path: '/devices/edit/:id',
    name: 'devices-edit',
    component: () => import('@/views/devices/DevicesEdit.vue'),
    meta: {transitionName: 'slide'},
  },
];
